'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { FEATURES_KEY } from 'src/constants/session';
import { AppFeatureList } from 'src/api/responses';
import { isSubFeatureEnabledIn } from 'src/utils/features';
import useAppStorage from './useAppStorage';
const useFeatures = () => {
  const $ = _c(18);
  const {
    setItem,
    getItem
  } = useAppStorage();
  let t0;
  if ($[0] !== setItem) {
    t0 = flags => {
      if (!flags || !Array.isArray(flags)) {
        console.warn("Invalid feature flags provided. Expected an array of AppFeatureList.");
        return;
      }
      setItem(FEATURES_KEY, JSON.stringify(flags));
    };
    $[0] = setItem;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setFeatureFlags = t0;
  let t1;
  if ($[2] !== getItem) {
    t1 = () => {
      const featuresData = getItem(FEATURES_KEY);
      if (!featuresData) {
        return [];
      }
      ;
      try {
        const features = JSON.parse(featuresData) as AppFeatureList[];
        if (!Array.isArray(features)) {
          console.warn("Invalid feature flags format. Expected an array.");
          return [];
        }
        return features;
      } catch (t2) {
        const error = t2;
        console.error("Error parsing feature flags from storage:", error);
        return [];
      }
    };
    $[2] = getItem;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getFeatures = t1;
  let t2;
  if ($[4] !== getFeatures) {
    t2 = featureKey => {
      const features_0 = getFeatures();
      return features_0.find(feature => feature.key === featureKey);
    };
    $[4] = getFeatures;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getFeature = t2;
  let t3;
  if ($[6] !== getFeature) {
    t3 = (featureKey_0, t4) => {
      const defaultValue = t4 === undefined ? false : t4;
      const feature_0 = getFeature(featureKey_0);
      if (!feature_0) {
        return defaultValue;
      }
      return feature_0.enabled;
    };
    $[6] = getFeature;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const isFeatureEnabled = t3;
  let t4;
  if ($[8] !== getFeatures) {
    t4 = (featureKey_1, subFeatureKey, t5) => {
      const defaultValue_0 = t5 === undefined ? false : t5;
      return isSubFeatureEnabledIn(getFeatures(), featureKey_1, subFeatureKey, defaultValue_0);
    };
    $[8] = getFeatures;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const isSubFeatureEnabled = t4;
  let t5;
  if ($[10] !== getFeatures) {
    t5 = () => {
      const features_1 = getFeatures();
      return features_1?.length >= 0;
    };
    $[10] = getFeatures;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const areFeaturesReady = t5;
  let t6;
  if ($[12] !== areFeaturesReady || $[13] !== getFeature || $[14] !== isFeatureEnabled || $[15] !== isSubFeatureEnabled || $[16] !== setFeatureFlags) {
    t6 = {
      setFeatureFlags,
      setFeatures: setFeatureFlags,
      isFeatureEnabled,
      isEnabled: isFeatureEnabled,
      isSubFeatureEnabled,
      getFeature,
      areFeaturesReady
    };
    $[12] = areFeaturesReady;
    $[13] = getFeature;
    $[14] = isFeatureEnabled;
    $[15] = isSubFeatureEnabled;
    $[16] = setFeatureFlags;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default useFeatures;